const LIST_ELEMENT_QUERY_HOMEPAGE = [
  {
    name: 'SectionCourseOnline',
    key: 'course-online'
  },
  {
    name: 'SectionCourseOffline',
    key: 'course-offline'
  },
  {
    name: 'SectionEventList',
    key: 'academic-event'
  },
  {
    name: 'SectionDepartment',
    key: 'academic-department'
  },
  {
    name: 'SectionEbook',
    key: 'book'
  },
  {
    name: 'SectionLearningPath',
    key: 'learning-path'
  }
]

const MENU_HEADER_HOMEPAGE = [
  {
    name: 'topics',
    icon: 'hambuger_menu',
  },
  {
    name: 'program',
    label: ('$vuetify.LEARNING_SYLLABUS'),
    children: [
      {
        label: ('$vuetify.ONLINE_COURSE.TITLE_SHORT'),
        href: '/course-online/',
      },
      {
        label: ('$vuetify.OFFLINE_COURSE.TITLE_SHORT'),
        href: '/course-offline/',
      },
      {
        label: ('$vuetify.MENU.BOOK'),
        href: '/book-list/',
      },
      {
        label: ('$vuetify.EVENT.TITLE_SHORT'),
        href: '/event-list/',
      },
    ],
  },
  {
    name: 'activeCourse',
    label: ('$vuetify.MENU.HEADER.ACTIVATE'),
    href: '/active-course/',
  },
  {
    name: 'department',
    label: ('$vuetify.MENU.DEPARTMENT'),
    href: '/department/',
  },
  {
    name: 'blog',
    label: '$vuetify.MENU.BLOG',
    href: '/blog/',
  },
  {
    name: 'aboutUs',
    label: ('$vuetify.MENU.ABOUT_US'),
    href: '/about-us/',
  },
  {
    name: 'policy',
    label: ('$vuetify.MENU.PRIVACY_POLICY'),
    href: '/privacy-policy/',
  },
  {
    name: 'recruitment',
    label: ('$vuetify.MENU.HEADER.RECRUITMENT'),
    href: '/recruitment/',
  },
]

const FOOTER_EDUCATON_CONTENT = [
  {
    name: "activeCourse",
    label: ('$vuetify.MENU.FOOTER.ACTIVATE_COURSE'),
    href: "/active-course",
  },
  {
    name: "courseOnline",
    label: ('$vuetify.ONLINE_COURSE.TITLE_SHORT'),
    href: "/course-online",
  },
  {
    name: "courseOffline",
    label: ('$vuetify.OFFLINE_COURSE.TITLE_SHORT'),
    href: "/course-offline",
  },
  {
    name: "event",
    label: ('$vuetify.EVENT.TITLE_SHORT'),
    href: "/event-list",
  },
  {
    name: "ebook",
    label: ('$vuetify.MENU.BOOK'),
    href: "/book-list",
  },
]

const FOOTER_INTRO_CONTENT = [
  {
    name: "aboutUs",
    label: ('$vuetify.MENU.ABOUT_US'),
    href: "/about-us",
  },
  {
    name: "policy",
    label: ('$vuetify.MENU.PRIVACY_POLICY'),
    href: "/privacy-policy",
  },
  {
    name: "blog",
    label: ('$vuetify.MENU.BLOG'),
    href: "/blog",
  },
  {
    name: "department",
    label: ('$vuetify.MENU.DEPARTMENT'),
    href: "/department",
  },
]

const QUERY_HOMEPAGE = {
  'course-online': {
    ids: [],
    fields: [
      'id',
      'vendorId',
      'createdAt',
      'status',
      'topics',
      'authors',
      'previewImg',
      'title',
      'shortDescription',
      'isFree',
      'price',
      'disablePurchasing',
      'video'
    ]
  },
  'course-offline': {
    ids: [],
    fields: [
      'id',
      'vendorId',
      'status',
      'topics',
      'authors',
      'metadata',
      'previewImg',
      'duration',
      'title',
      'price',
      'description',
      'shortDescription',
    ]
  },
  'academic-event': {
    ids: [],
    fields: [
      'id',
      'vendorId',
      'createdAt',
      'previewImage',
      'runningStartDate',
      'title',
      'runningStartHour',
      'center'
    ]
  },
  'academic-department': {
    ids: [],
    fields: ['id', 'vendorId', 'createdAt', 'previewImage', 'name']
  },
  book: {
    ids: [],
    fields: [
      'id',
      'vendorId',
      'createdAt',
      'previewImage',
      'authors',
      'title'
    ]
  },
  'learning-path': {
    ids: [],
  },
}

const commentEnums = {
  countTypeEnums: {
    TOTAL: 'TOTAL',
    COMMENT: 'COMMENT',
    REPLY: 'REPLY',
  }
}

const RATING_ENUMS = {
  ONLINE_COURSE: 'ONLINE_COURSE',
  BOOK: 'BOOK',
  LEARNING_PATH: 'LEARNING_PATH'
}

const DEFAULT_IMAGE = {
  avatarProfile: '/learn-static/avatar.jpeg',
  card: process.env.VUE_APP_AWS_BUCKET_S3_DEFAULT_DATA + '/SD-default-image.png',
  banner: process.env.VUE_APP_AWS_BUCKET_S3_DEFAULT_DATA + '/banner-default.jpg',
  avatar: 'https://online-learning-izteach-3-test-aws-source-bucket.s3.ap-southeast-1.amazonaws.com/resource/images/23b0bfb0-c00b-11e9-a060-17d3861b7a5b/avatar.png',
  logo: process.env.VUE_APP_AWS_BUCKET_S3_DEFAULT_DATA + '/root-logo.png'
}

const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCjne_QylOujuf2dL1Pv8m-P_hxXtpHD8Q",
  authDomain: "bigdat-izteach.firebaseapp.com",
  databaseURL: "https://bigdat-izteach-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bigdat-izteach",
  storageBucket: "bigdat-izteach.appspot.com",
  messagingSenderId: "522926608836",
  appId: "1:522926608836:web:3ef48970498ec7d77e5491",
  measurementId: "G-HYZ0CX5Y3T"
};

const FIREBASE_WEB_PUSH_CERT = 'BDB0QCM4BPUIZKyuJZWSfl7lcH_DIAZcFnuYd-z7-k92M4cIMsjR0cHeVQzNUS6LMwvWDPZ3J-rgwlfE7Vuu9lU'

const EXAM_TYPE = ['exercise', 'test', 'matrix']

export default {
  LIST_ELEMENT_QUERY_HOMEPAGE,
  QUERY_HOMEPAGE,
  MENU_HEADER_HOMEPAGE,
  FOOTER_EDUCATON_CONTENT,
  FOOTER_INTRO_CONTENT,
  DEFAULT_IMAGE,
  commentEnums,
  FIREBASE_CONFIG,
  RATING_ENUMS,
  EXAM_TYPE,
  FIREBASE_WEB_PUSH_CERT,
}